module.exports = __webpack_public_path__ + "static/media/Groceries.2f4f5111.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Calculator/icons/Groceries.png
// module id = 573
// module chunks = 0